import styled from '@emotion/styled'
import Box from '@mui/material/Box'

export const NoWrap = styled(Box)`
  && {
    white-space: nowrap;
  }
`
